export enum SituacaoLancamentoDespesa {
  PENDENTE = 'PENDENTE',
  PAGO = 'PAGO',
  CANCELADO = 'CANCELADO',
}

export const DESCRICAO_SITUACAO_LANCAMENTO_DESPESA: { [key in SituacaoLancamentoDespesa]: string } = {
  [SituacaoLancamentoDespesa.PENDENTE]: 'Pendente',
  [SituacaoLancamentoDespesa.PAGO]: 'Pago',
  [SituacaoLancamentoDespesa.CANCELADO]: 'Cancelado',
};
